export default __webpack_public_path__ + "static/media/toplist.375b6f95.svg";